import React from 'react'
import PDFView from './View/PDFView'
// import ExcelView from './View/ExcelView'

function ReportPreview({ format, file }) {
  let view = null

  switch (format) {
    case 'pdf':
      view = <PDFView file={file} />
      break
    // case 'xls':
    //   view = <ExcelView file={file} />
    //   break
    default:
      break
  }

  return view
}

export default ReportPreview
